import { useState } from 'react';
import { Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import Page from '@/components/layout/Page';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import BackButton from '@/components/common/BackButton';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardFooter
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';

import { useActivities } from '@/data/activity';
import { useSelf } from '@/data/user';
import { useCoachActivities } from '@/data/coachActivity';

import ApplicationSteps from './components/ApplicationSteps';

const AddApplicationPage = () => {
  const activities = useActivities();
  const coachActivities = useCoachActivities();
  const navigate = useNavigate();
  const [selectedActivityId, setSelectedActivityId] = useState('');
  const self = useSelf();

  if (activities.isLoading && !activities.data) {
    return null;
  }

  if (self.isLoading && !self.data) {
    return null;
  }

  if (coachActivities.isLoading && !coachActivities.data) {
    return null;
  }

  const handleBeginApplication = () => {
    if (self.data.coach?.id) {
      navigate(
        `/application/coach/${self.data.coach.id}?activityId=${selectedActivityId}`
      );
    } else {
      navigate(`/application/coach/add?activityId=${selectedActivityId}`);
    }
  };

  const existingActivitiesForUser = coachActivities.data?.map(
    (ca) => ca.activityId
  );
  const potentialNewActivities = activities.data.filter(
    (activity) => !existingActivitiesForUser?.includes(activity.id)
  );

  return (
    <Page>
      <BackButton to={`/setting`} />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Become a ProFound Pro</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="mb-6">
            <Select
              onValueChange={setSelectedActivityId}
              value={selectedActivityId}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select an activity" />
              </SelectTrigger>
              <SelectContent>
                {potentialNewActivities.map((activity) => (
                  <SelectItem key={activity.id} value={activity.id}>
                    {activity.title}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {selectedActivityId && (
            <Alert>
              <Clock size={18} />
              <AlertTitle>Application Process</AlertTitle>
              <AlertDescription>
                The application process takes about 10 - 15 minutes. Please
                review the following steps and gather the required documents
                before starting.
              </AlertDescription>
            </Alert>
          )}
          {selectedActivityId && (
            <ApplicationSteps activityId={selectedActivityId} />
          )}
        </CardContent>
        {selectedActivityId && (
          <CardFooter className="flex justify-end">
            <Button onClick={handleBeginApplication}>Begin</Button>
          </CardFooter>
        )}
      </Card>
      <div className="p-10"></div>
    </Page>
  );
};

export default AddApplicationPage;
